/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompany
 */
export interface ControlCompany {
    /**
     * 
     * @type {string}
     * @memberof ControlCompany
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompany
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompany
     */
    type: string;
}

/**
 * Check if a given object implements the ControlCompany interface.
 */
export function instanceOfControlCompany(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlCompanyFromJSON(json: any): ControlCompany {
    return ControlCompanyFromJSONTyped(json, false);
}

export function ControlCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'name': json['name'],
        'type': json['type'],
    };
}

export function ControlCompanyToJSON(value?: ControlCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'name': value.name,
        'type': value.type,
    };
}

